import * as React from "react";
import { Pressable, StyleSheet } from "react-native";
import { Text, Surface, useTheme, Button, Avatar } from "react-native-paper";
import { useSelector } from "react-redux";
import { spacing } from "@styles/spacing";
import { formatCurrency } from "../../../util/format-currency";
import { getTwoCharacterFromName } from "../../../util/validate";
import { Block } from "@block";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import ScreenNameType from "@navigation/nav-screens";
import { useDesktopMediaQuery } from "@media-query";
import { useTranslation } from "react-i18next";
import { SideMenuContext } from "../../side-menu/side-menu";
import { navigationRef } from "app/shared/util/root-navigator";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { Constant } from "app/shared/constant/constant";
import {
  getListAccountCustomerSelector,
  getListAccountSelector,
  getUserProfileSelector,
} from "app/modules/account-management/reducer/selectors";
import { ACCOUNT } from "app/shared/services/services-model.type";

const AccountInfo = () => {
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const [showBalance, setShowBalance] = React.useState(false);
  const { hideMenu } = React.useContext(SideMenuContext);
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        containerMenu: {
          borderRadius: 20,
          paddingHorizontal: spacing.huge,
        },
        textBlack: { color: colors.text, ...fonts.medium, fontSize: 12 },
        whiteBlack: { color: colors.surface, ...fonts.medium, fontSize: 12 },
        buttonsStyles: { flex: 1, borderRadius: 24 },
        nameStyles: { ...fonts.semibold, color: colors.text, fontSize: 14, maxWidth: "100%", textAlign: "center" },
        textAccType: { ...fonts.regular, color: colors.text },
        textAmountStyles: { ...fonts.regular, color: colors.text, alignSelf: "center" },
        moneyAmountStyles: { color: colors.accent, ...fonts.semibold, alignItems: "baseline" },
      }),
    [colors, fonts],
  );
  // get Data Info
  const userProfile = useSelector(getUserProfileSelector);
  const listAccountStore = useSelector(getListAccountSelector);
  const listAccountCustomerStore = useSelector(getListAccountCustomerSelector);

  const [currenBalance, setCurrenBalance] = React.useState<string>("0");

  const onPressManager = () => {
    hideMenu();
    navigationRef?.current?.navigate(ScreenNameType.ACCOUNT_ROLL);
  };

  const onPressAvatar = () => {
    hideMenu();
    navigationRef?.current?.navigate(ScreenNameType.INFORMATION_ACCOUNT);
  };
  const onPressStatement = () => {
    hideMenu();
    navigationRef?.current?.navigate(ScreenNameType.LIST_STATEMENT);
  };

  const handlerCustomerPosition = React.useCallback(() => {
    let listFilter: ACCOUNT[] = [];
    if (listAccountCustomerStore && listAccountCustomerStore?.length) {
      listFilter = listAccountCustomerStore.filter((acc) => {
        return acc.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT && acc?.CURRENCYCODE === "VND";
      });
    } else if (listAccountStore?.ACCOUNT && listAccountStore?.ACCOUNT.length) {
      listFilter = listAccountStore.ACCOUNT.filter((acc) => {
        return (
          acc.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT &&
          acc?.CURRENCYCODE === "VND" &&
          acc.PRODUCTCODE !== Constant.PRODUCT_CODE_PRD26
        );
      });
    }
    return listFilter;
  }, [listAccountCustomerStore, listAccountStore]);

  const handlerBalance = React.useCallback(
    (listAccount: ACCOUNT[]): string => {
      let balance: string = "* * * * * *";
      if (showBalance) {
        let amount = 0;
        listAccount.forEach((acc) => {
          if (acc?.CURRENTBALANCE?.length && !Number.isNaN(Number(String(acc.CURRENTBALANCE).replace(/,/g, "")))) {
            amount += Number(String(acc.CURRENTBALANCE).replace(/,/g, ""));
          }
        });
        balance = formatCurrency(amount);
      }
      return balance;
    },
    [showBalance],
  );

  React.useEffect(() => {
    const list = handlerCustomerPosition();
    setCurrenBalance(handlerBalance(list));
  }, [handlerBalance, handlerCustomerPosition]);

  return (
    <Surface style={styles.containerMenu}>
      <StackSpacing size="large" />
      <Block middle row center>
        <Pressable onPress={onPressAvatar}>
          <Avatar.Text size={56} label={getTwoCharacterFromName(userProfile?.FULLNAME)} />
        </Pressable>
      </Block>
      <StackSpacing size="small" />
      <Block flex={1} flexwrap>
        <Text numberOfLines={2} style={styles.nameStyles}>
          {userProfile?.FULLNAME || t("COMMON_HO_TEN")}
        </Text>
      </Block>
      <StackSpacing size="small" />
      <Block row center spaced style={{ alignItems: showBalance ? "center" : "baseline" }}>
        <Text style={styles.textAmountStyles}>{t("ACC_SO_DU")}:</Text>
        <Text children={currenBalance} style={styles.moneyAmountStyles} />
        <Pressable onPress={() => setShowBalance((prev) => !prev)}>
          <MaterialCommunityIcons name={showBalance ? "eye-off" : "eye"} size={20} />
        </Pressable>
      </Block>
      <StackSpacing size="medium" />
      <Block row={isDesktop ? true : false}>
        <Button
          uppercase={false}
          labelStyle={styles.textBlack}
          mode="contained"
          style={styles.buttonsStyles}
          color={colors.primary}
          onPress={onPressManager}>
          {t("ACC_QUAN_LY")}
        </Button>
        <QueueSpacing size="small" />
        <StackSpacing size="small" />
        <Button
          uppercase={false}
          labelStyle={styles.whiteBlack}
          mode="contained"
          style={styles.buttonsStyles}
          color={colors.accent}
          onPress={onPressStatement}>
          {t("ACC_SAO_KE")}
        </Button>
      </Block>
      <StackSpacing size="large" />
    </Surface>
  );
};

export default AccountInfo;
